import { IssueCommentResponse } from 'common-module/src/components/Epic/Model/comment';
import http from 'common-module/src/util/http';

export const getCommentList = async (
  issueId: number,
  projectId: number,
  field = 'create_time',
  order: 'desc' | 'asc' = 'desc',
  requestOptions = {}
): Promise<IssueCommentResponse> => {
  return http.post(
    '/sys-comment/issue/list-comment',
    {
      linkId: issueId,
      pageSize: 9999,
      pageNumber: 1,
      projectId,
      queryOrderBy: { field: field, desc: order === 'desc' }
    },
    {
      showError: false,
      ...requestOptions
    }
  );
};

//这个用reminderId
export const markCommentMessageRead = async (reminderId: number): Promise<void> => {
  return http.post('/msg/mark-category-read', {
    id: reminderId
  });
};

//这个用commandId
export const markCommentIdMessageRead = async (
  commandId: number | string,
  issueId: number | string,
  channel: string
): Promise<void> => {
  return http.post('/msg/comment-relationship-msg/as-read', {
    channel,
    commandId,
    issueId
  });
};

export const queryUnReadComment = async (
  issueId: number | string
): Promise<any> => {
  return http.post('/sys-comment/issue/unread-comment', {
    issueId
  });
};

export const recordLastViewCommentTime = async (
  issueId: number | string,
  recordTime: number
): Promise<any> => {
  return http.post('/sys-comment/issue/set-comment-record', {
    issueId,
    recordTime
  });
};
